// 配置 开发环境、生产环境baseurl地址
const CONFIG = {
  // 开发环境配置
  development: {
    baseUrl: "http://192.168.2.230:8100",
    ssoBaseUrl: "http://192.168.2.230:8100",
    // ssoBaseUrl: "http://192.168.2.230:10010",
    client_id:'dinghnsodampcj3tkcvb',
    isDev: true,
  },
  // 测试环境配置
  test: {
    baseUrl: "http://192.168.2.232:8100",
    ssoBaseUrl: "http://192.168.2.232:8100",
    client_id:'dingtbolourunzx75ent',
    isDev: true,
  },
  testUAT: {
    baseUrl: "http://192.168.2.235:8100",
    ssoBaseUrl: "http://192.168.2.235:8100",
    client_id:'dingtbolourunzx75ent',
    isDev: true,
  },
  // 生产环境配置
  production: {
    baseUrl: "https://lead.truckbao.com",
    ssoBaseUrl: "https://lead.truckbao.com",
    client_id:'dingpsaduwrhj3ah7skr',
    isDev: false,
  },
};

module.exports = CONFIG[process.env.VUE_APP_ENV || process.env.NODE_ENV];
